module.exports = __webpack_public_path__ + "img/Turkey.c20a8d77.png";